exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmbedViewer-9f8fdc6f{position:relative;display:block;width:100%;max-height:700px}.EmbedViewer-9f8fdc6f iframe{position:absolute;width:100%;height:100%;top:0;left:0;right:0;bottom:0}\n", ""]);

// Exports
exports.locals = {
	"EmbedViewer": "EmbedViewer-9f8fdc6f"
};